var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#963E97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9C8.89543 9 8 9.89543 8 11V21C8 22.1046 8.89543 23 10 23H22C23.1046 23 24 22.1046 24 21V11C24 9.89543 23.1046 9 22 9H10ZM13.7124 19.6062C13.7124 20.0481 14.0706 20.4062 14.5124 20.4062C14.9542 20.4062 15.3124 20.0481 15.3124 19.6062L15.3124 12.3938C15.3124 11.9519 14.9542 11.5938 14.5124 11.5938C14.0706 11.5938 13.7124 11.9519 13.7124 12.3938V19.6062ZM11.5124 20.4062C11.0706 20.4062 10.7124 20.0481 10.7124 19.6062V17.2052C10.7124 16.7633 11.0706 16.4052 11.5124 16.4052C11.9542 16.4052 12.3124 16.7633 12.3124 17.2052V19.6062C12.3124 20.0481 11.9542 20.4062 11.5124 20.4062ZM19.7437 19.6062C19.7437 20.0481 20.1018 20.4062 20.5437 20.4062C20.9855 20.4062 21.3437 20.0481 21.3437 19.6062V17.2052C21.3437 16.7633 20.9855 16.4052 20.5437 16.4052C20.1018 16.4052 19.7437 16.7633 19.7437 17.2052V19.6062ZM17.5124 20.4062C17.0706 20.4062 16.7124 20.0481 16.7124 19.6062V14.7235C16.7124 14.2817 17.0706 13.9235 17.5124 13.9235C17.9542 13.9235 18.3124 14.2817 18.3124 14.7235V19.6062C18.3124 20.0481 17.9542 20.4062 17.5124 20.4062Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductivity);
export default __webpack_public_path__ + "static/media/productivity.3ffc9619d25b1f9cc54eabd20eb303f9.svg";
export { ForwardRef as ReactComponent };